import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'

export interface PageConfig {
  viewName: string;
  scrollPosition: number;
  orderBy: string;
  descending: boolean;
  custom: { [name: string]: string };
}

interface Path {
  path: string;
}

export interface ScrollPositionPayload extends Path {
  position: number;
}

export interface ViewNamePayload extends Path {
  viewName: string;
}

export interface OrderedByPayload extends Path {
  orderedBy: string;
}

export interface DescendingPayload extends Path {
  descending: boolean;
}

export interface CustomPayload extends Path {
  custom: { [name: string]: string };
}

@Module({ namespaced: true })
class PageConfigs extends VuexModule {
  private pageConfigs: { [path: string]: PageConfig } = {}

  @Mutation
  public setCustom (payload: CustomPayload): void {
    const p: PageConfig = this.pageConfigs[payload.path] || {}
    p.custom = payload.custom
    this.pageConfigs[payload.path] = p
  }

  @Mutation
  public setScrollPosition (payload: ScrollPositionPayload): void {
    const p: PageConfig = this.pageConfigs[payload.path] || {}
    p.scrollPosition = payload.position
    this.pageConfigs[payload.path] = p
  }

  @Mutation
  public setViewName (payload: ViewNamePayload): void {
    const p: PageConfig = this.pageConfigs[payload.path] || {}
    p.viewName = payload.viewName
    this.pageConfigs[payload.path] = p
  }

  @Mutation
  public setOrderBy (payload: OrderedByPayload): void {
    const p: PageConfig = this.pageConfigs[payload.path] || {}
    p.orderBy = payload.orderedBy
    this.pageConfigs[payload.path] = p
  }

  @Mutation
  public setDescending (payload: DescendingPayload): void {
    const p: PageConfig = this.pageConfigs[payload.path] || {}
    p.descending = payload.descending
    this.pageConfigs[payload.path] = p
  }

  @Action
  public async getPageConfig (path: string): Promise<PageConfig> {
    const pageConfig = this.pageConfigs[path]
    return {
      viewName: pageConfig ? pageConfig.viewName || 'default' : 'default',
      scrollPosition: pageConfig ? pageConfig.scrollPosition || 0 : 0,
      orderBy: pageConfig ? pageConfig.orderBy || 'Name' : 'Name',
      descending: pageConfig ? pageConfig.descending || true : true,
      custom: pageConfig ? pageConfig.custom || {} : {}
    }
  }
}
export default PageConfigs
